var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1415 6.74615C11.9075 6.87239 11.7616 7.11243 11.7616 7.37351V11.439H3.73429C3.32896 11.439 3 11.7603 3 12.1562C3 12.5522 3.32896 12.8735 3.73429 12.8735H11.7616V16.9389C11.7616 17.201 11.9075 17.441 12.1415 17.5663C12.3755 17.6935 12.6614 17.6849 12.8875 17.5462L20.6573 12.7635C20.8708 12.6315 21 12.403 21 12.1562C21 11.9095 20.8708 11.6809 20.6573 11.5489L12.8875 6.76623C12.7681 6.69355 12.632 6.65625 12.4959 6.65625C12.3745 6.65625 12.2521 6.68685 12.1415 6.74615Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.bea5a071b554d2c562617d183800acf8.svg";
export { ForwardRef as ReactComponent };